import type { SsrComponentModule } from './hydrateSsrComponentList';

const shellModules = new Map<string, SsrComponentModule>();

/**
 * Stores listing-shell modules already pulled into the fat client graph.
 * Hydration reads this map so those components are not dynamic-imported again.
 *
 * @param modules - Component name → module, from the eager glob in the fat entry.
 */
export function registerListingFatShellModules(
  modules: Record<string, SsrComponentModule>,
) {
  for (const [name, componentModule] of Object.entries(modules)) {
    shellModules.set(name, componentModule);
  }
}

/**
 * Returns a shell module bundled with the listing fat entry.
 *
 * @param name - SSR component name.
 * @returns The preloaded module, or undefined when this entry did not register it.
 */
export function getListingFatShellModule(name: string): SsrComponentModule | undefined {
  return shellModules.get(name);
}
